import React, { useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useHeaderConfig } from "../../NavProvider";
import { HamburgerMenuIcon } from "../../../icons";
import AstroLogo from "../AstroLogo";
import SsoButton from "../SsoButton";
import Container from "../Container";
import MobileDrawer from "../MobileDrawer";
import { MenuDrawer, trackMobileNavEvent } from "../analytics";
var useStyles = makeStyles(function () {
    return createStyles({
        wrapper: {
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            height: "56px",
            WebkitTapHighlightColor: "transparent",
        },
        center: {
            display: "flex",
            alignItems: "center",
        },
        grid: {
            display: "grid",
            gridAutoFlow: "column",
            gridGap: "20px",
        },
        burgerMenu: {
            cursor: "pointer",
        },
    });
});
var MobileNav = function () {
    var styles = useStyles();
    var header = useHeaderConfig();
    var _a = useState(false), showDrawer = _a[0], setShowDrawer = _a[1];
    var handleClick = function () {
        setShowDrawer(true);
        trackMobileNavEvent(MenuDrawer.Open);
    };
    var handleClose = function () {
        setShowDrawer(false);
        trackMobileNavEvent(MenuDrawer.Close);
    };
    return (React.createElement(Container, null,
        React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.grid },
                React.createElement("div", { className: clsx(styles.center, styles.burgerMenu), onClick: handleClick, id: "headerDrawer" },
                    React.createElement(HamburgerMenuIcon, null)),
                React.createElement(AstroLogo, { logo: header.logo })),
            React.createElement("div", { className: styles.center },
                React.createElement(SsoButton, null))),
        showDrawer && React.createElement(MobileDrawer, { open: showDrawer, onClose: handleClose })));
};
export default MobileNav;
